@if(language.startsWith('de')){

<h1><strong>Allgemeine Geschäftsbedingungen</strong></h1>

<h3 id="-1-einleitung-und-geltungsbereich-"><strong>1. Einleitung und Geltungsbereich</strong></h3>
<p>
  1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der Dienstleistungen der
  Alphabees UG (haftungsbeschränkt) (im Folgenden „Alphabees“, „wir“, „uns“ oder „unsere“),
  einschließlich unserer KI-Agent- und Verwaltungsplattform sowie aller damit verbundenen Abonnement-Modelle.
</p>
<p>
  1.2 Mit der Registrierung oder Nutzung unserer Dienstleistungen akzeptieren Sie diese AGB.
  Diese AGB gelten für alle Kunden und Nutzer (im Folgenden „Kunden“, „Nutzer“ oder „Sie“).
</p>
<p>
  1.3 Abweichende oder zusätzliche Bedingungen des Kunden gelten nur, wenn wir diesen ausdrücklich schriftlich zugestimmt haben.
</p>
<hr />

<h3 id="-2-leistungsbeschreibung-"><strong>2. Leistungsbeschreibung</strong></h3>
<p>
  2.1 Alphabees bietet eine webbasierte Plattform zur Verwaltung und Durchführung von KI-gestützten Tutoring-Diensten
  sowie damit verbundenen Funktionen. Alles, was der Kunde einschließlich seiner Nutzer konfiguriert, hochlädt oder
  auf andere Weise durch den Service nutzt, gilt als „Nutzerbeitrag“. Der Kunde ist allein verantwortlich für alle
  Nutzerbeiträge, die er oder seine Nutzer auf der Plattform erstellen oder bereitstellen.
</p>
<p>
  2.2 Der Kunde erwirbt ein Abonnement für den Zugriff auf die von Alphabees angebotenen Dienstleistungen, wie im jeweiligen
  Vertrag, Angebot oder Produktplan beschrieben. Der Zugang und die Nutzung der Dienste sind ausschließlich für den internen
  Gebrauch des Kunden und seiner autorisierten Nutzer vorgesehen.
</p>
<p>
  2.3 Der Leistungsumfang unserer Dienste richtet sich nach dem jeweils vom Kunden gewählten Abonnementplan.
  Jeder Plan kann Nutzungskontingente enthalten, insbesondere hinsichtlich der Anzahl von Anfragen, Token-Limits,
  Dateiuploads und Speicherkapazitäten.
</p>
<p>
  2.4 Eine Anfrage ist eine Verbindung oder Interaktion mit unserer Schnittstelle, über die KI-Tutoring-Funktionen genutzt werden.
  Jede neue Interaktion oder Abfrage über die Schnittstelle kann als eine Anfrage zählen.
</p>
<p>
  2.5 Tokens sind die kleinsten Verarbeitungseinheiten, die bei der Bearbeitung von Texten durch KI-Systeme verwendet werden.
  Der Tokenverbrauch hängt von der Länge und Komplexität der Eingaben sowie der generierten Ausgaben ab. Es können sowohl
  eingegebene Tokens als auch ausgegebene Tokens gezählt werden.
</p>
<p>
  2.6 Soweit Nutzungskontingente vereinbart sind und eines der vereinbarten Limits erreicht ist, kann die Nutzung der Dienste
  eingeschränkt oder blockiert werden. Weitere Nutzung kann durch ein Upgrade oder eine gesonderte Vereinbarung ermöglicht werden.
</p>
<p>
  2.7 Kunden können ihren aktuellen Verbrauch, soweit technisch bereitgestellt, über das Kundenportal einsehen. Alphabees kann den
  Kunden informieren, sobald bestimmte Nutzungsschwellen erreicht werden.
</p>
<p>
  2.8 Alphabees behält alle Rechte, Titel und Interessen einschließlich aller geistigen Eigentumsrechte an der Software, den Inhalten
  und allen Materialien, die im Rahmen des Services bereitgestellt werden. Der Kunde erhält kein Recht auf Zugriff auf den Quellcode
  oder die zugrunde liegende Software.
</p>
<p>
  2.9 Der Kunde bzw. die jeweiligen Rechteinhaber behalten sämtliche Rechte an den von ihnen in das System hochgeladenen Inhalten und
  Materialien. Alphabees erhält lediglich ein nicht-exklusives, auf die Vertragslaufzeit beschränktes Nutzungsrecht an diesen Inhalten,
  soweit dies zur Erbringung der vertraglich vereinbarten Dienstleistungen erforderlich ist. Eine darüberhinausgehende Nutzung,
  insbesondere zum Training eigener KI-Modelle von Alphabees oder Dritten, erfolgt nicht, sofern dies nicht ausdrücklich gesondert
  vereinbart wurde.
</p>
<p>
  2.10 Alphabees behält sich das Recht vor, die Dienste weiterzuentwickeln und Änderungen vorzunehmen, die den Funktionsumfang verbessern,
  ohne die vereinbarten Kernfunktionen wesentlich zu beeinträchtigen.
</p>
<hr />

<h3 id="-3-einschraenkungen-"><strong>3. Einschränkungen</strong></h3>
<p>
  3.1 Der Kunde ist für alle Aktivitäten auf seinem Konto sowie auf den Konten seiner Nutzer verantwortlich, es sei denn,
  diese Aktivitäten resultieren aus einem von Alphabees zu vertretenden unbefugten Zugriff auf die Plattform.
</p>
<p>
  3.2 Der Kunde verpflichtet sich, den Service nicht zu modifizieren, zurückzuentwickeln, zu dekompilieren oder zu versuchen,
  den Quellcode zu extrahieren. Der Kunde wird den Service nicht in einer Weise nutzen, die gegen geltendes Recht verstößt
  oder die Integrität, Sicherheit oder Verfügbarkeit des Services gefährdet.
</p>
<p>
  3.3 Falls Alphabees APIs bereitstellt, behält sich Alphabees das Recht vor, angemessene Nutzungsgrenzen festzulegen und den
  API-Zugang bei Verstößen, Sicherheitsrisiken oder missbräuchlicher Nutzung zu suspendieren oder zu beenden.
</p>
<hr />

<h3 id="-4-drittanbieter-dienste-"><strong>4. Drittanbieter-Dienste</strong></h3>
<p>
  4.1 Unsere Dienste können Schnittstellen zu Produkten, Dienstleistungen oder Anwendungen von Drittanbietern beinhalten, die nicht
  von Alphabees kontrolliert oder betrieben werden („Drittanbieter-Dienste“). Kunden können diese Drittanbieter-Dienste in Verbindung
  mit unseren Diensten nutzen. Soweit hierfür Zugangsdaten oder Berechtigungen erforderlich sind, ist der Kunde für deren Bereitstellung
  und Rechtmäßigkeit verantwortlich.
</p>
<p>
  4.2 Alphabees empfiehlt oder billigt keine Drittanbieter-Dienste. Der Kunde erkennt an, dass für Drittanbieter-Dienste gesonderte
  Bedingungen der jeweiligen Anbieter gelten können. Alphabees übernimmt keine Haftung für Probleme, die aus der Nutzung oder der
  Unfähigkeit zur Nutzung von Drittanbieter-Diensten resultieren, sofern Alphabees diese nicht zu vertreten hat.
</p>
<p>
  4.3 Die Nutzung von Drittanbieter-Diensten erfolgt auf eigenes Risiko des Kunden.
</p>
<hr />

<h3 id="-5-vertragslaufzeit-kuendigung-und-aenderungen-"><strong>5. Vertragslaufzeit, Kündigung und Änderungen</strong></h3>
<p><strong>5.1 Abonnementmodelle und Mindestlaufzeit</strong></p>
<p>
  Alphabees bietet, je nach vereinbartem Produktplan, Angebot oder Vertrag, monatliche und jährliche Abonnementmodelle an.
</p>
<ul>
  <li>Bei einem Monatsabonnement beträgt die Mindestlaufzeit 1 Monat. Das Monatsabonnement verlängert sich automatisch um jeweils einen weiteren Monat, sofern es nicht fristgerecht gekündigt wird.</li>
  <li>Bei einem Jahresabonnement beträgt die Mindestlaufzeit 12 Monate. Das Jahresabonnement verlängert sich automatisch um jeweils weitere 12 Monate, sofern es nicht fristgerecht gekündigt wird.</li>
</ul>
<p><strong>5.2 Kündigung und Fristen</strong></p>
<ul>
  <li>Bei Monatsabonnements beträgt die Kündigungsfrist 1 Monat zum Ende des jeweiligen Abrechnungszeitraums.</li>
  <li>Bei Jahresabonnements beträgt die Kündigungsfrist 3 Monate zum Ende des jeweiligen Abrechnungszeitraums.</li>
  <li>Änderungen wie Downgrades treten erst zum Ende der laufenden Abrechnungsperiode in Kraft.</li>
</ul>
<p><strong>5.3 Upgrades</strong></p>
<p>
  Ein Upgrade bedeutet, dass der Kunde von einem bestehenden Abonnementplan auf einen Plan mit einem höheren Leistungsumfang wechselt.
  Dies kann insbesondere die Erhöhung von Kontingenten für Anfragen, Tokens, Dateiuploads oder Speicherkapazitäten umfassen.
</p>
<p>
  Upgrades werden nach Zahlungseingang oder nach gesonderter Freigabe durch Alphabees wirksam. Nicht genutzte Kontingente aus dem
  vorherigen Plan können mit dem Wechsel auf den neuen Plan verfallen, sofern nicht ausdrücklich etwas anderes vereinbart wurde.
</p>
<hr />

<h3 id="-6-abrechnung-und-zahlung-"><strong>6. Abrechnung und Zahlung</strong></h3>
<p><strong>6.1 Abrechnungszyklus</strong></p>
<p>
  Der Abrechnungszyklus richtet sich nach dem gewählten Abonnementmodell. Bei einem Monatsabonnement erfolgt die Abrechnung monatlich.
  Bei einem Jahresabonnement erfolgt die Abrechnung jährlich. Der Abrechnungszeitraum beginnt mit Vertragsschluss oder mit Freischaltung
  des Zugangs, sofern nicht ausdrücklich etwas anderes vereinbart wurde.
</p>
<p><strong>6.2 Zahlungsarten</strong></p>
<p>
  Die Zahlung erfolgt wahlweise über den Zahlungsdienstleister Stripe oder per Vorkasse durch Überweisung, sofern diese Zahlungsart von
  Alphabees angeboten oder vereinbart wurde.
</p>
<p><strong>6.3 Zahlungsbedingungen</strong></p>
<p>
  Zahlungen sind zu Beginn des jeweiligen Abrechnungszeitraums im Voraus fällig. Bei Zahlung per Vorkasse wird vorab eine Rechnung erstellt.
  Die Freischaltung des Zugangs erfolgt nach Zahlungseingang, sofern nicht ausdrücklich etwas anderes vereinbart wurde.
</p>
<p><strong>6.4 Zahlungsabwicklung über Stripe</strong></p>
<p>
  Bei Zahlung über Stripe erfolgt die Zahlungsabwicklung über den Zahlungsdienstleister Stripe. Rechnungen können im Kundenportal bereitgestellt
  und von Stripe erstellt werden. Alphabees speichert keine vollständigen zahlungsrelevanten Daten wie Kreditkartennummern. Zahlungsdaten werden
  durch Stripe verarbeitet.
</p>
<p><strong>6.5 Rückerstattung</strong></p>
<p>
  Bereits geleistete Zahlungen werden nicht erstattet, sofern gesetzlich nichts anderes vorgeschrieben ist.
</p>
<p><strong>6.6 Zahlungsverzug</strong></p>
<p>
  Bei Zahlungsverzug kann der Zugang zu den Diensten, einschließlich WebSocket-Verbindungen, bis zur vollständigen Begleichung der offenen Beträge
  gesperrt werden.
</p>
<hr />

<h3 id="-7-nutzungsrechte-und-datenlizenz-"><strong>7. Nutzungsrechte und Datenlizenz</strong></h3>
<p>
  7.1 Kunden gewähren Alphabees eine nicht-exklusive, weltweite und unentgeltliche Lizenz zur Nutzung, Verarbeitung und Anzeige der von ihnen
  bereitgestellten Inhalte und Daten („Nutzerdaten“), jedoch ausschließlich soweit dies zur Bereitstellung der vereinbarten Dienstleistungen
  erforderlich ist.
</p>
<p>
  7.2 Die Rechte an den von Kunden eingereichten Daten verbleiben vollständig beim Kunden bzw. den jeweiligen Rechteinhabern. Es werden keine
  stillschweigenden Rechte oder Lizenzen gewährt.
</p>
<hr />

<h3 id="-8-datenschutz-und-datenloeschung-"><strong>8. Datenschutz und Datenlöschung</strong></h3>
<p>
  8.1 Alphabees verarbeitet personenbezogene Daten gemäß der Datenschutz-Grundverordnung (DSGVO) und den deutschen Datenschutzgesetzen.
  Details zur Datenverarbeitung finden Sie in unserer Datenschutzerklärung.
</p>
<p>
  8.2 Kunden bleiben Verantwortliche im Sinne der DSGVO für die von ihnen hochgeladenen personenbezogenen Daten. Alphabees fungiert als
  Auftragsverarbeiter und verarbeitet diese Daten ausschließlich auf Weisung der Kunden und zur Erbringung der vereinbarten Dienstleistungen.
</p>
<p>
  8.3 Die produktive Verarbeitung und Speicherung kundenbezogener Daten erfolgt auf Servern der Hetzner Online GmbH mit Serverstandort Deutschland,
  insbesondere Nürnberg. Alphabees hat mit der Hetzner Online GmbH einen Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO abgeschlossen.
</p>
<p>
  8.4 Die Entwicklungsumgebung von Alphabees kann weiterhin auf Servern der Contabo GmbH in Deutschland betrieben werden. Die Entwicklungsumgebung
  ist von der produktiven Kundenumgebung getrennt und dient internen Entwicklungs-, Test- und Wartungszwecken. Soweit in diesem Zusammenhang
  personenbezogene Daten verarbeitet werden, erfolgt dies auf Grundlage geeigneter datenschutzrechtlicher Vereinbarungen gemäß Art. 28 DSGVO.
</p>
<p>
  8.5 Alphabees verwendet geeignete technische und organisatorische Maßnahmen, um die Vertraulichkeit, Integrität und Verfügbarkeit der Daten zu
  gewährleisten. Dies umfasst insbesondere Maßnahmen wie Verschlüsselung, Zugriffskontrollen und regelmäßige Sicherheitsüberprüfungen.
</p>
<p>
  8.6 Nach Beendigung des Vertragsverhältnisses werden die vom Kunden gespeicherten Daten grundsätzlich innerhalb von 30 Tagen gelöscht, sofern
  keine gesetzlichen Aufbewahrungspflichten, berechtigten Interessen oder abweichenden vertraglichen Vereinbarungen entgegenstehen.
</p>
<p>
  8.7 Der Kunde hat die Möglichkeit, seine Daten vor Vertragsende zu exportieren oder eine Herausgabe in einem geeigneten Format anzufordern,
  soweit dies technisch möglich und vertraglich vereinbart ist.
</p>
<p>
  8.8 Sicherheitskopien und Backups können aus technischen Gründen für einen begrenzten Zeitraum weiter gespeichert bleiben. Sie werden nicht mehr
  produktiv genutzt und im Rahmen der regulären Backup-Zyklen automatisch überschrieben oder gelöscht.
</p>
<p>
  8.9 Mit der Akzeptanz dieser AGB erklären Kunden sich damit einverstanden, dass Alphabees die für die Bereitstellung der Dienste erforderlichen
  personenbezogenen Daten gemäß DSGVO verarbeitet. Dies umfasst die Verarbeitung von Daten zur Vertragserfüllung sowie zur Erfüllung gesetzlicher Pflichten.
</p>
<hr />

<h3 id="-9-haftungsbeschraenkung-"><strong>9. Haftungsbeschränkung</strong></h3>
<p>
  9.1 Alphabees haftet für Schäden nur bei Vorsatz oder grober Fahrlässigkeit. Bei leichter Fahrlässigkeit haftet Alphabees ausschließlich bei der
  Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), und die Haftung ist auf den vorhersehbaren, typischerweise eintretenden Schaden begrenzt.
</p>
<p>
  9.2 Alphabees haftet nicht für indirekte, besondere, zufällige oder Folgeschäden, einschließlich entgangener Gewinne, Geschäftsverluste oder Datenverluste,
  selbst wenn Alphabees auf die Möglichkeit solcher Schäden hingewiesen wurde, soweit dies rechtlich zulässig ist.
</p>
<p>
  9.3 Die Haftung der Alphabees UG (haftungsbeschränkt), ihrer Geschäftsführer und gesetzlichen Vertreter ist auf die Höhe der vom Kunden gezahlten Gebühren
  in den letzten zwölf (12) Monaten vor dem Schadensfall begrenzt, soweit dies rechtlich zulässig ist. Eine persönliche Haftung der Geschäftsführer wird
  ausdrücklich ausgeschlossen, soweit dies rechtlich zulässig ist.
</p>
<p>
  9.4 Diese Haftungsbeschränkungen gelten nicht bei Verletzung von Leben, Körper oder Gesundheit sowie bei Ansprüchen nach dem Produkthaftungsgesetz.
</p>
<hr />

<h3 id="-10-vertraulichkeit-"><strong>10. Vertraulichkeit</strong></h3>
<p>
  10.1 Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit ausgetauschten vertraulichen Informationen geheim zu halten.
</p>
<p>
  10.2 Vertrauliche Informationen dürfen nur mit ausdrücklicher Zustimmung der anderen Partei oder wenn dies gesetzlich vorgeschrieben ist weitergegeben werden.
</p>
<p>
  10.3 Die Bestimmungen über Vertraulichkeit bleiben auch nach Beendigung des Vertragsverhältnisses bestehen.
</p>
<hr />

<h3 id="-11-veroeffentlichung-"><strong>11. Veröffentlichung</strong></h3>
<p>
  Mit vorheriger schriftlicher Zustimmung des Kunden darf Alphabees den Namen, das Logo und die Marken des Kunden zu Marketingzwecken nutzen,
  z. B. auf der Website oder in Präsentationen. Dies geschieht stets unter Beachtung der geltenden Datenschutzbestimmungen.
</p>
<hr />

<h3 id="-12-aenderungen-der-agb-"><strong>12. Änderungen der AGB</strong></h3>
<p>
  12.1 Alphabees behält sich das Recht vor, diese AGB zu ändern. Änderungen werden mindestens 30 Tage vor Inkrafttreten angekündigt.
</p>
<p>
  12.2 Kunden, die den Änderungen nicht zustimmen, haben das Recht, ihr Abonnement mit Wirkung zum Zeitpunkt des Inkrafttretens der Änderungen zu kündigen.
</p>
<hr />

<h3 id="-13-schlussbestimmungen-"><strong>13. Schlussbestimmungen</strong></h3>
<p>
  13.1 Diese AGB unterliegen deutschem Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist, soweit gesetzlich zulässig,
  der Sitz der Alphabees UG (haftungsbeschränkt).
</p>
<p>
  13.2 Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleiben die übrigen Bestimmungen davon unberührt.
</p>
<p>
  13.3 Diese AGB begründen keine Rechte für Dritte.
</p>
<p>
  13.4 Vertragssprache ist Deutsch.
</p>

}@else {

<h1><strong>General Terms and Conditions</strong></h1>

<h3 id="-1-introduction-and-scope-"><strong>1. Introduction and Scope</strong></h3>
<p>
  1.1 These General Terms and Conditions (GTC) govern the use of the services of Alphabees UG (haftungsbeschränkt)
  (hereinafter referred to as "Alphabees", "we", "us", or "our"), including our AI tutor and management platform and all
  associated subscription models.
</p>
<p>
  1.2 By registering or using our services, you accept these GTC. These GTC apply to all customers and users (hereinafter referred
  to as "customers", "users", or "you").
</p>
<p>
  1.3 Deviating or additional terms of the customer shall only apply if we have expressly agreed to them in writing.
</p>
<hr />

<h3 id="-2-service-description-"><strong>2. Service Description</strong></h3>
<p>
  2.1 Alphabees provides a web-based platform for managing and conducting AI-supported tutoring services and related functions.
  Everything the customer, including its users, configures, uploads, or otherwise uses through the service is considered a "user contribution".
  The customer is solely responsible for all user contributions created or provided on the platform.
</p>
<p>
  2.2 The customer acquires a subscription for access to the services offered by Alphabees, as described in the relevant contract,
  offer, or product plan. Access to and use of the services is intended solely for the internal use of the customer and its authorized users.
</p>
<p>
  2.3 The scope of our services is determined by the subscription plan selected by the customer. Each plan may include usage quotas,
  in particular regarding the number of requests, token limits, file uploads, and storage capacity.
</p>
<p>
  2.4 A request is a connection or interaction with our interface through which AI tutoring functions are used. Each new interaction or query
  via the interface may count as one request.
</p>
<p>
  2.5 Tokens are the smallest processing units used by AI systems when processing text. Token consumption depends on the length and complexity
  of the input and generated output. Both input tokens and output tokens may be counted.
</p>
<p>
  2.6 If usage quotas have been agreed and one of the agreed limits is reached, use of the services may be restricted or blocked. Further use
  may be enabled through an upgrade or separate agreement.
</p>
<p>
  2.7 Customers may view their current usage through the customer portal, where technically provided. Alphabees may inform the customer when
  certain usage thresholds are reached.
</p>
<p>
  2.8 Alphabees retains all rights, titles, and interests, including all intellectual property rights, in the software, content, and materials
  provided as part of the service. The customer receives no right to access the source code or underlying software.
</p>
<p>
  2.9 The customer or respective rights holders retain all rights to content and materials uploaded into the system. Alphabees receives only a
  non-exclusive usage right limited to the contract term to the extent necessary to provide the agreed services. Any further use, in particular
  for training Alphabees' own AI models or third-party AI models, shall not take place unless expressly agreed separately.
</p>
<p>
  2.10 Alphabees reserves the right to further develop the services and make changes that improve functionality without materially impairing the
  agreed core functions.
</p>
<hr />

<h3 id="-3-restrictions-"><strong>3. Restrictions</strong></h3>
<p>
  3.1 The customer is responsible for all activities on its account and on the accounts of its users, unless such activities result from
  unauthorized access to the platform for which Alphabees is responsible.
</p>
<p>
  3.2 The customer agrees not to modify, reverse engineer, decompile, or attempt to extract the source code of the service. The customer shall
  not use the service in a way that violates applicable law or jeopardizes the integrity, security, or availability of the service.
</p>
<p>
  3.3 If Alphabees provides APIs, Alphabees reserves the right to set reasonable usage limits and to suspend or terminate API access in case of
  violations, security risks, or abusive use.
</p>
<hr />

<h3 id="-4-third-party-services-"><strong>4. Third-Party Services</strong></h3>
<p>
  4.1 Our services may include interfaces to third-party products, services, or applications that are not controlled or operated by Alphabees
  ("third-party services"). Customers may use these third-party services in connection with our services. Where access credentials or permissions
  are required, the customer is responsible for providing them lawfully.
</p>
<p>
  4.2 Alphabees does not recommend or endorse any third-party services. The customer acknowledges that separate terms of the respective providers
  may apply to third-party services. Alphabees assumes no liability for issues arising from the use or inability to use third-party services unless
  Alphabees is responsible for such issues.
</p>
<p>
  4.3 The use of third-party services is at the customer's own risk.
</p>
<hr />

<h3 id="-5-contract-duration-termination-and-changes-"><strong>5. Contract Duration, Termination, and Changes</strong></h3>
<p><strong>5.1 Subscription models and minimum term</strong></p>
<p>
  Alphabees offers monthly and annual subscription models depending on the agreed product plan, offer, or contract.
</p>
<ul>
  <li>For monthly subscriptions, the minimum term is 1 month. The monthly subscription renews automatically for another month unless terminated in due time.</li>
  <li>For annual subscriptions, the minimum term is 12 months. The annual subscription renews automatically for another 12 months unless terminated in due time.</li>
</ul>
<p><strong>5.2 Termination and notice periods</strong></p>
<ul>
  <li>For monthly subscriptions, the notice period is 1 month to the end of the respective billing period.</li>
  <li>For annual subscriptions, the notice period is 3 months to the end of the respective billing period.</li>
  <li>Changes such as downgrades take effect only at the end of the current billing period.</li>
</ul>
<p><strong>5.3 Upgrades</strong></p>
<p>
  An upgrade means that the customer switches from an existing subscription plan to a plan with a higher scope of services. This may include,
  in particular, increasing quotas for requests, tokens, file uploads, or storage capacity.
</p>
<p>
  Upgrades become effective upon receipt of payment or upon separate approval by Alphabees. Unused quotas from the previous plan may expire when
  switching to the new plan unless expressly agreed otherwise.
</p>
<hr />

<h3 id="-6-billing-and-payment-"><strong>6. Billing and Payment</strong></h3>
<p><strong>6.1 Billing cycle</strong></p>
<p>
  The billing cycle depends on the selected subscription model. Monthly subscriptions are billed monthly. Annual subscriptions are billed annually.
  The billing period begins upon conclusion of the contract or activation of access unless expressly agreed otherwise.
</p>
<p><strong>6.2 Payment methods</strong></p>
<p>
  Payment is made either via the payment service provider Stripe or by advance payment via bank transfer, provided this payment method is offered
  or agreed by Alphabees.
</p>
<p><strong>6.3 Payment terms</strong></p>
<p>
  Payments are due in advance at the beginning of the respective billing period. In the case of advance payment, an invoice is issued in advance.
  Access is activated after receipt of payment unless expressly agreed otherwise.
</p>
<p><strong>6.4 Payment processing via Stripe</strong></p>
<p>
  If payment is made via Stripe, payment processing is carried out by the payment service provider Stripe. Invoices may be provided in the customer
  portal and created by Stripe. Alphabees does not store complete payment-related data such as credit card numbers. Payment data is processed by Stripe.
</p>
<p><strong>6.5 Refunds</strong></p>
<p>
  Payments already made are non-refundable unless otherwise required by law.
</p>
<p><strong>6.6 Payment default</strong></p>
<p>
  In the event of payment default, access to the services, including WebSocket connections, may be suspended until the outstanding amounts have been
  paid in full.
</p>
<hr />

<h3 id="-7-usage-rights-and-data-license-"><strong>7. Usage Rights and Data License</strong></h3>
<p>
  7.1 Customers grant Alphabees a non-exclusive, worldwide, royalty-free license to use, process, and display the content and data they provide
  ("user data"), but only to the extent necessary to provide the agreed services.
</p>
<p>
  7.2 The rights to data submitted by customers remain fully with the customer or the respective rights holders. No implied rights or licenses are granted.
</p>
<hr />

<h3 id="-8-data-protection-and-data-deletion-"><strong>8. Data Protection and Data Deletion</strong></h3>
<p>
  8.1 Alphabees processes personal data in accordance with the General Data Protection Regulation (GDPR) and German data protection laws.
  Details on data processing can be found in our Privacy Policy.
</p>
<p>
  8.2 Customers remain the controllers within the meaning of the GDPR for the personal data they upload. Alphabees acts as a processor and processes
  this data solely on the instructions of customers and for the provision of the agreed services.
</p>
<p>
  8.3 Productive processing and storage of customer-related data takes place on servers of Hetzner Online GmbH with server location in Germany,
  in particular Nuremberg. Alphabees has concluded a data processing agreement with Hetzner Online GmbH in accordance with Art. 28 GDPR.
</p>
<p>
  8.4 Alphabees' development environment may continue to be operated on servers of Contabo GmbH in Germany. The development environment is separated
  from the productive customer environment and is used for internal development, testing, and maintenance purposes. Where personal data is processed
  in this context, this is done on the basis of appropriate data protection agreements in accordance with Art. 28 GDPR.
</p>
<p>
  8.5 Alphabees uses appropriate technical and organizational measures to ensure the confidentiality, integrity, and availability of data. This includes,
  in particular, measures such as encryption, access controls, and regular security reviews.
</p>
<p>
  8.6 After termination of the contractual relationship, data stored by the customer will generally be deleted within 30 days, unless statutory retention
  obligations, legitimate interests, or deviating contractual agreements prevent deletion.
</p>
<p>
  8.7 The customer has the option to export its data before the end of the contract or request its return in a suitable format, insofar as this is
  technically possible and contractually agreed.
</p>
<p>
  8.8 Security copies and backups may continue to be stored for a limited period for technical reasons. They will no longer be used productively and will
  be automatically overwritten or deleted as part of the regular backup cycles.
</p>
<p>
  8.9 By accepting these GTC, customers agree that Alphabees processes the personal data necessary to provide the services in accordance with the GDPR.
  This includes processing data for contract fulfillment and for compliance with legal obligations.
</p>
<hr />

<h3 id="-9-liability-limitation-"><strong>9. Liability Limitation</strong></h3>
<p>
  9.1 Alphabees is liable for damages only in cases of intent or gross negligence. In cases of slight negligence, Alphabees is liable only for the
  breach of essential contractual obligations (cardinal obligations), and liability is limited to the foreseeable, typically occurring damage.
</p>
<p>
  9.2 Alphabees is not liable for indirect, special, incidental, or consequential damages, including lost profits, business losses, or data losses,
  even if Alphabees has been advised of the possibility of such damages, to the extent legally permissible.
</p>
<p>
  9.3 The liability of Alphabees UG (haftungsbeschränkt), its managing directors, and legal representatives is limited to the amount of fees paid by
  the customer in the twelve (12) months preceding the damaging event, to the extent legally permissible. Personal liability of the managing directors
  is expressly excluded to the extent legally permissible.
</p>
<p>
  9.4 These liability limitations do not apply in cases of injury to life, body, or health, or to claims under the Product Liability Act.
</p>
<hr />

<h3 id="-10-confidentiality-"><strong>10. Confidentiality</strong></h3>
<p>
  10.1 Both parties undertake to keep all confidential information exchanged during the collaboration secret.
</p>
<p>
  10.2 Confidential information may only be disclosed with the express consent of the other party or if required by law.
</p>
<p>
  10.3 The confidentiality provisions shall survive termination of the contractual relationship.
</p>
<hr />

<h3 id="-11-publication-"><strong>11. Publication</strong></h3>
<p>
  With the customer's prior written consent, Alphabees may use the customer's name, logo, and trademarks for marketing purposes, for example on
  the website or in presentations. This is always done in compliance with applicable data protection regulations.
</p>
<hr />

<h3 id="-12-changes-to-the-gtc-"><strong>12. Changes to the GTC</strong></h3>
<p>
  12.1 Alphabees reserves the right to change these GTC. Changes will be announced at least 30 days before they take effect.
</p>
<p>
  12.2 Customers who do not agree to the changes have the right to terminate their subscription with effect from the time the changes take effect.
</p>
<hr />

<h3 id="-13-final-provisions-"><strong>13. Final Provisions</strong></h3>
<p>
  13.1 These GTC are subject to German law, excluding the UN Sales Convention. The place of jurisdiction is, to the extent legally permissible,
  the registered office of Alphabees UG (haftungsbeschränkt).
</p>
<p>
  13.2 Should individual provisions of these GTC be invalid, the remaining provisions shall remain unaffected.
</p>
<p>
  13.3 These GTC do not create any rights for third parties.
</p>
<p>
  13.4 The contract language is German.
</p>

}
